/**
 * 路由权限控制
 * Created by PeakXin on 2025/10/29
 * Optimized on 2025/11/03
 */
import router from './router'
import store from './store'
import { Toast } from 'vant'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

import { getToken, redirectToWechatAuth } from '@/utils/wxauth'
import getPageTitle from '@/utils/get-page-title'
import { getQueryParam } from '@/utils'

// 引入白名单配置
import { WHITE_LIST } from '@/config/whitelist'

/* ----------------------------
 * NProgress 配置
 * ---------------------------- */
NProgress.configure({ showSpinner: false })

/* ----------------------------
 * 路由前置守卫
 * ---------------------------- */
router.beforeEach(async (to, from, next) => {
  // 启动进度条
  NProgress.start()

  // 设置动态页面标题
  if (to.meta?.title) {
    document.title = getPageTitle(to.meta.title)
  }

  const isWhiteListed = WHITE_LIST.includes(to.path) || WHITE_LIST.includes(to.name)
  store.commit('app/SET_IS_WHITE_LISTED', isWhiteListed)
  // 白名单放行
  if (isWhiteListed) {
    next()
    NProgress.done()
    return
  }

  // 获取本地 Token
  const hasToken = getToken()

  if (hasToken) {
    // 验证Token是否有效
    try {
      await store.dispatch('user/validateToken')
      next()
    } catch (error) {
      console.warn('[Auth] Token 无效或过期:', error)
      await store.dispatch('user/resetToken')
      NProgress.done()
      redirectToWechatAuth()
    }
  } else {
    // 无 Token：进入微信授权流程
    const code = getQueryParam('code')
    const state = getQueryParam('state')

    if (!code || !state) {
      console.log('[Auth] 缺少授权参数，跳转微信授权')
      NProgress.done()
      redirectToWechatAuth()
      return
    }

    try {
      // 获取 Token
      console.log(code, state)
      await store.dispatch('user/getToken', { code, state })
      next()
    } catch (err) {
      console.error('[Auth] 微信授权失败:', err)
      Toast.fail(err?.message || '微信授权失败，请稍后重试')
    } finally {
      NProgress.done()
    }
  }
})

/**
 * 路由后置守卫
 */
router.afterEach(() => {
  // 完成进度条
  NProgress.done()
})

/**
 * 路由错误处理
 */
router.onError((error) => {
  console.error('[Router] 路由错误:', error)
  NProgress.done()
  Toast.fail('页面加载失败')
})
